import {
  useGlobalComponentForAttribute,
  TableInheritedProps
} from '@rhino-project/core/hooks';
import { CellDateTime } from '../../table/cells/CellDateTime';

export const ModelCellDateTimeBase = (props: TableInheritedProps) => (
  <CellDateTime {...props} />
);

export const ModelCellDateTime = (props: TableInheritedProps) =>
  useGlobalComponentForAttribute(
    'ModelCellDateTime',
    ModelCellDateTimeBase,
    props
  );
